/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_On_StorefrontInputs */

const en_show_on_storefront = /** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show on Storefront`)
};

const id_show_on_storefront = /** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan di Etalase`)
};

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const es_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const fr_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const de_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const ja_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const zh_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const ar_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const it_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const ru_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const pt_show_on_storefront = en_show_on_storefront;

/** @type {(inputs: Show_On_StorefrontInputs) => LocalizedString} */
const ko_show_on_storefront = en_show_on_storefront;

/**
* | output |
* | --- |
* | "Show on Storefront" |
*
* @param {Show_On_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const show_on_storefront = /** @type {((inputs?: Show_On_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_On_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_show_on_storefront(inputs)
	if (locale === "es") return es_show_on_storefront(inputs)
	if (locale === "fr") return fr_show_on_storefront(inputs)
	if (locale === "de") return de_show_on_storefront(inputs)
	if (locale === "ja") return ja_show_on_storefront(inputs)
	if (locale === "zh") return zh_show_on_storefront(inputs)
	if (locale === "ar") return ar_show_on_storefront(inputs)
	if (locale === "id") return id_show_on_storefront(inputs)
	if (locale === "it") return it_show_on_storefront(inputs)
	if (locale === "ru") return ru_show_on_storefront(inputs)
	if (locale === "pt") return pt_show_on_storefront(inputs)
	return ko_show_on_storefront(inputs)
});